import { FC } from 'react';
import type { SeopTone } from '@/types/seop';

interface StatusPillProps {
  label: string;
  tone: SeopTone;
  /** Sem o ponto, vira a pill de percentual (utilização). */
  withDot?: boolean;
}

const TONE_CLASSES: Record<SeopTone, string> = {
  success: 'bg-theme-success/10 border-theme-success/40 text-theme-success',
  warning: 'bg-theme-warning/10 border-theme-warning/40 text-theme-warning',
  danger: 'bg-theme-danger/10 border-theme-danger/40 text-theme-danger',
};

const DOT_CLASSES: Record<SeopTone, string> = {
  success: 'bg-theme-success',
  warning: 'bg-theme-warning',
  danger: 'bg-theme-danger',
};

/**
 * Pill do semáforo. O tom vem de `seopStatus` — que reproduz o mapa de cor do
 * app original, onde `Balanceado` é âmbar e `Folga` é verde.
 */
const StatusPill: FC<StatusPillProps> = ({ label, tone, withDot = false }) => (
  <span
    className={`inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-xs font-semibold whitespace-nowrap ${TONE_CLASSES[tone]}`}
  >
    {withDot && <span className={`h-1.5 w-1.5 rounded-full ${DOT_CLASSES[tone]}`} aria-hidden="true" />}
    {label}
  </span>
);

export default StatusPill;
